"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.providers = void 0;
var providers = [
    {
        id: 112243,
        providerUid: "38f2b4af-9a52-436f-85d2-fe7e0c9a40f7",
        firstName: "STACI",
        middleName: "M",
        lastName: "GAGNE",
        displayName: "GAGNE, STACI",
        email: null,
        prefix: null,
        suffix: null,
        degree: "MD",
        providerType: null,
        pager: null,
        active: null,
        isPcpProvider: null,
        encounterId: null,
        providerServiceLocation: null,
        locations: [],
        identifiers: [
            {
                id: 666880,
                idNumber: "1746114",
                idTypeCode: "EPIC",
                identifierType: "IDNO",
                checkDigit: null,
                checkDigitScheme: null,
                assigningAuthority: {
                    id: 22384,
                    guid: {
                        uuid: "34d59dcd-5869-47a7-90b6-34586fc822a2"
                    },
                    name: null,
                    description: null,
                    namespaceId: "EPIC",
                    universalId: null,
                    universalIdType: null,
                    defaultIssuer: false,
                    assigningFacility: null
                },
                entityId: null,
                entityType: null,
                primary: true
            },
            {
                id: 666882,
                idNumber: "174611222",
                idTypeCode: "EPICS",
                identifierType: "IDNO",
                checkDigit: null,
                checkDigitScheme: null,
                assigningAuthority: {
                    id: 22384,
                    guid: {
                        uuid: "34d59dcd-5869-47a7-90b6-34586fc822a2"
                    },
                    name: null,
                    description: null,
                    namespaceId: "EPIC",
                    universalId: null,
                    universalIdType: null,
                    defaultIssuer: false,
                    assigningFacility: null
                },
                entityId: null,
                entityType: null,
                primary: false
            }
        ],
        specialties: [],
        subspecialties: []
    }
];
exports.providers = providers;
//# sourceMappingURL=providers.js.map